import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ModalPortal from '../ModalPortal';
import seo from '../../services/seo';
import PASSPORT_360_CONFIG from '../../constants/passport360Config';
import VERTICAL_CONFIG from '../../constants/verticalConfig';
import * as analytics from '../../services/analytics';
import isEmpty from 'lodash/isEmpty';
import imgPassportVideo from './passport-video.png';
import imgBill from './bill.jpg';
import './LandingPassport360.css';

const propTypes = {
  quote: PropTypes.object,
};

const defaultProps = {
  quote: {},
};

class LandingPassport360 extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeModal: null,
    };
  }

  componentDidMount() {
    analytics.page('Broker Portal - Passport 360 Landing');
    seo.setProps({
      title: 'Passport 360',
    });
  }

  showModal = (e) => {
    e.preventDefault();
    const modalId = e.currentTarget.dataset.modalId;
    analytics.track('Broker Portal - Passport 360 Video Modal Opened', {
      label: modalId,
    });
    this.setState(
      {
        activeModal: modalId,
      },
      () => {
        const $modal = window.$(this[modalId]);
        $modal.modal('show');
        $modal.on('hide.bs.modal', () => {
          this.setState({
            activeModal: null,
          });
        });
      }
    );
  };

  handleUnavailableVertical = () => {
    const modalId = 'unavailableModal';
    this.setState(
      {
        activeModal: modalId,
      },
      () => {
        const $modal = window.$(this[modalId]);
        $modal.modal('show');
        $modal.on('hide.bs.modal', () => {
          this.setState({
            activeModal: null,
          });
        });
      }
    );
  };

  handleLinkCTA = () => {
    const { quote, location } = this.props;

    if (isEmpty(quote)) {
      return {
        pathname: `passport360/start/policyholder`,
        search: location.search,
      };
    } else {
      return `passport360/enroll/${quote.quote_number}/policyholder`;
    }
  };

  trackDocClick = (e) => {
    analytics.track('Broker Portal - External Link Clicked', {
      label: e.target.dataset.key,
    });
  };

  render() {
    const { activeModal } = this.state;

    return (
      <div className="LandingPassport360">
        <div
          className="LandingPassport360-hero"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${process.env.PUBLIC_URL}/img/landing-passport360-hero.jpg)`,
          }}
        >
          <h1 className="LandingPassport360-hero-heading">
            Passport 360 is a different kind of Travel Insurance. It's an annual
            policy that covers you and your family, no matter how many trips you
            decide to take throughout the year. You're going places. Passport360
            is right there with you!
          </h1>
          {VERTICAL_CONFIG.IS_PASSPORT360_ENABLED ? (
            <Link
              className="LandingPassport360-hero-cta btn btn-primary btn-large"
              to={this.handleLinkCTA}
            >
              Check Our Prices
            </Link>
          ) : (
            <button
              className="LandingPassport360-hero-cta btn btn-primary btn-large"
              onClick={this.handleUnavailableVertical}
            >
              Check Our Prices
            </button>
          )}
          <a
            href="https://www.youtube.com/watch?v=T9gCgZb4J2E&feature=youtu.be"
            className="LandingPassport360-hero-videoLink"
            data-modal-id="passportOverviewModal"
            onClick={this.showModal}
          >
            <img
              className="LandingPassport360-hero-videoLink-img"
              src={imgPassportVideo}
              alt="Passport 360 Video Preview"
            />
          </a>
        </div>

        <div className="LandingPassport360-tagline">
          Passport 360 delivers a complete package
        </div>

        <div className="LandingPassport360-highlightsThreeUps">
          <div className="container">
            <div className="row">
              <div className="LandingPassport360-threeUp col-md-4">
                <div className="LandingPassport360-threeUp-heading">
                  <div className="LandingPassport360-threeUp-heading-icon">
                    <i className="far fa-globe" />
                  </div>
                  <p className="LandingPassport360-threeUp-heading-title">
                    Comprehensive
                  </p>
                </div>
                <p className="LandingPassport360-threeUp-info">
                  You and your family are protected 24/7/365 during business and
                  pleasure travel, no matter where you travel.
                </p>
              </div>
              <div className="LandingPassport360-threeUp col-md-4">
                <div className="LandingPassport360-threeUp-heading">
                  <div className="LandingPassport360-threeUp-heading-icon">
                    <i className="fas fa-binoculars" />
                  </div>
                  <p className="LandingPassport360-threeUp-heading-title">
                    Innovative
                  </p>
                </div>
                <p className="LandingPassport360-threeUp-info">
                  Coverages and services that offer tailored solutions and
                  choices to meet your unique needs.
                </p>
              </div>
              <div className="LandingPassport360-threeUp col-md-4">
                <div className="LandingPassport360-threeUp-heading">
                  <div className="LandingPassport360-threeUp-heading-icon">
                    <i className="far fa-umbrella" />
                  </div>
                  <p className="LandingPassport360-threeUp-heading-title">
                    Seamless
                  </p>
                </div>
                <p className="LandingPassport360-threeUp-info">
                  One annual premium covers travel throughout the year; there’s
                  no need to activate on a trip-by-trip basis.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="LandingPassport360-details">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 className="LandingPassport360-details-heading">
                  Choose from two plan levels -- Essential and Enhanced – The
                  two plans offer many of the same benefits, but at different
                  coverage levels.
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <h3 className="LandingPassport360-details-listHeading">
                  Benefits included:
                </h3>
                <ul className="LandingPassport360-details-list">
                  <li className="LandingPassport360-details-listItem">
                    <i className="LandingPassport360-details-listItem-icon fa fa-check" />
                    Medical evacuation for illness and injury and safe return
                    home
                  </li>
                  <li className="LandingPassport360-details-listItem">
                    <i className="LandingPassport360-details-listItem-icon fa fa-check" />
                    Coverage for medical expenses while traveling outside the
                    U.S (excess coverage)
                  </li>
                  <li className="LandingPassport360-details-listItem">
                    <i className="LandingPassport360-details-listItem-icon fa fa-check" />
                    Political evacuation, such as situations of political unrest
                    and military action
                  </li>
                  <li className="LandingPassport360-details-listItem">
                    <i className="LandingPassport360-details-listItem-icon fa fa-check" />
                    Additional death benefit in case of criminal assault
                  </li>
                  <li className="LandingPassport360-details-listItem">
                    <i className="LandingPassport360-details-listItem-icon fa fa-check" />
                    Additional benefits in case of accidental loss of limbs,
                    sight, speech, hearing or paralysis
                  </li>
                </ul>
              </div>
              <div className="col-md-4">
                <h3 className="LandingPassport360-details-listHeading">
                  Travel conveniences included:
                </h3>
                <ul className="LandingPassport360-details-list">
                  <li className="LandingPassport360-details-listItem">
                    <i className="LandingPassport360-details-listItem-icon fa fa-check" />
                    Trip delay coverage
                  </li>
                  <li className="LandingPassport360-details-listItem">
                    <i className="LandingPassport360-details-listItem-icon fa fa-check" />
                    Baggage delay coverage
                  </li>
                  <li className="LandingPassport360-details-listItem">
                    <i className="LandingPassport360-details-listItem-icon fa fa-check" />
                    Travel assistance services such as replacement of lost
                    travel documents like your passport or visa, translation
                    services, rebooking an itinerary, medical and legal
                    referrals, identity protection, and more
                  </li>
                  <li className="LandingPassport360-details-listItem">
                    <i className="LandingPassport360-details-listItem-icon fa fa-check" />
                    Analysis of your travel risks from a robust security
                    intelligence website
                  </li>
                </ul>
              </div>
              <div className="col-md-4">
                <h3 className="LandingPassport360-details-listHeading">
                  Optional upgrade:
                </h3>
                <ul className="LandingPassport360-details-list">
                  <li className="LandingPassport360-details-listItem">
                    <i className="LandingPassport360-details-listItem-icon fa fa-check" />
                    Golf package – Coverage for green fees if you can’t make
                    your tee-time, recreational equipment delay, and
                    recreational vehicle damage
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="LandingPassport360-testimonials">
          <div className="container">
            <div className="row">
              <div className="LandingPassport360-testimonial col-12">
                <img
                  className="LandingPassport360-testimonial-image m-r-40"
                  src={imgBill}
                  alt="Bill's Testimonial"
                />
                <div className="LandingPassport360-testimonial-content">
                  <h4 className="LandingPassport360-testimonial-heading">
                    Passport 360, A Personal Story
                  </h4>
                  <p className="LandingPassport360-testimonial-info">
                    After Bill was injured in a remote area while on vacation,
                    Chubb had him evacuated quickly and easily.
                  </p>
                  <a
                    href="https://www.youtube.com/watch?v=wjhQDKjQ4Hc"
                    className="LandingPassport360-testimonial-link"
                    data-modal-id="billModal"
                    onClick={this.showModal}
                  >
                    <i className="LandingPassport360-testimonial-link-icon fas fa-play" />
                    See Bill’s Story
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="LandingPassport360-banner">
          <div className="container">
            <h3 className="LandingPassport360-banner-heading">
              The programs we offer are uniquely designed to cover the
              unexpected risks related to travel, helping our clients travel
              without worry.
            </h3>
            {VERTICAL_CONFIG.IS_PASSPORT360_ENABLED ? (
              <Link
                className="LandingPassport360-banner-cta btn btn-primary btn-large"
                to={this.handleLinkCTA}
              >
                Get Quote Now
              </Link>
            ) : (
              <button
                className="LandingPassport360-banner-cta btn btn-primary btn-large"
                onClick={this.handleUnavailableVertical}
              >
                Get Quote Now
              </button>
            )}
          </div>
        </div>

        <div className="LandingPassport360-footer">
          <div className="LandingPassport360-footer-content">
            <p className="LandingPassport360-footer-faq">
              Need help? Click to download{' '}
              <a
                href={PASSPORT_360_CONFIG.planOverviewUrl}
                className="text-complete"
                target="_blank"
                rel="noopener noreferrer"
                data-key="planOverview"
                onClick={this.trackDocClick}
              >
                view product brochure
              </a>
              {', '}
              <a
                href={PASSPORT_360_CONFIG.faqDocUrl}
                className="text-complete"
                rel="noopener noreferrer"
                target="_blank"
                data-key="faq"
                onClick={this.trackDocClick}
              >
                frequently asked questions
              </a>
              , and{' '}
              <a
                href={PASSPORT_360_CONFIG.eaServicesUrl}
                className="text-complete"
                rel="noopener noreferrer"
                target="_blank"
                data-key="eaServices"
                onClick={this.trackDocClick}
              >
                travel assistance services
              </a>
              .
            </p>
            <p className="LandingPassport360-footer-disclaimer">
              This information is a brief description of the important features
              of this insurance plan. It is not an insurance contract. Insurance
              benefits are underwritten by Federal Insurance Company. Coverage
              may not be available in all states or certain terms may be
              different where required by state law. Chubb NA is the U.S.-based
              operating division of the Chubb Group of Companies, headed by
              Chubb Ltd. (NYSE:CB) Insurance products and services are provided
              by Chubb Insurance underwriting companies and not by the parent
              company itself.
            </p>
          </div>
        </div>

        {activeModal === 'passportOverviewModal' && (
          <ModalPortal>
            <div
              className="modal fill-in"
              id="passportOverviewModal"
              ref={(c) => (this.passportOverviewModal = c)}
            >
              <iframe
                title="Passport 360 Overview"
                src="https://www.youtube.com/embed/T9gCgZb4J2E?autoplay=1;showinfo=0"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
            </div>
          </ModalPortal>
        )}
        {activeModal === 'billModal' && (
          <ModalPortal>
            <div
              className="modal fill-in"
              id="billModal"
              ref={(c) => (this.billModal = c)}
            >
              <iframe
                title="Passport 360 a Personal Travel Story"
                src="https://www.youtube.com/embed/wjhQDKjQ4Hc?autoplay=1;showinfo=0"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
            </div>
          </ModalPortal>
        )}
        {activeModal === 'evanModal' && (
          <ModalPortal>
            <div
              className="modal fill-in"
              id="evanModal"
              ref={(c) => (this.evanModal = c)}
            >
              <iframe
                title="Chubb will make things right"
                src="https://www.youtube.com/embed/HS5pnk7U7q8?autoplay=1;showinfo=0"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
            </div>
          </ModalPortal>
        )}
        {activeModal === 'unavailableModal' && (
          <ModalPortal>
            <div
              className="modal"
              id="unavailableModal"
              ref={(c) => (this.unavailableModal = c)}
            >
              <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content-wrapper">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Passport 360</h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Passport 360 is temporarily unavailable. Please try
                        again later.
                      </p>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="submit"
                        className="btn btn-complete"
                        data-dismiss="modal"
                      >
                        Ok
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalPortal>
        )}
      </div>
    );
  }
}

LandingPassport360.propTypes = propTypes;
LandingPassport360.defaultProps = defaultProps;

export default LandingPassport360;
